// The cardio sports a plan event can hold (from cardio/sports.ts), with labels and the target in words.
import { CARDIO_SPORTS, isCardioSport } from '../cardio/sports';
import type { PlanTarget } from './calendar';

/** Sport id to label ("running": "Running"), for pickers and the MCP coach. */
export const PLAN_ACTIVITIES: Record<string, string> = Object.fromEntries(Object.entries(CARDIO_SPORTS).map(([id, s]) => [id, s.label]));

export function activityLabel(activity: string): string {
  return isCardioSport(activity) ? CARDIO_SPORTS[activity].label : activity.replace(/_/g, ' ').replace(/^./, (c) => c.toUpperCase());
}

/** "Running, trail, 8 km" (the variant and the distance when set). */
export function plannedActivityText(activity: string, target?: PlanTarget | null): string {
  const parts = [activityLabel(activity)];
  if (target?.variant && isCardioSport(activity)) {
    const v = CARDIO_SPORTS[activity].variants[target.variant];
    if (v) parts.push(v.toLowerCase());
  }
  if (target?.distanceKm) {
    const meters = isCardioSport(activity) && CARDIO_SPORTS[activity].meters;
    parts.push(meters ? `${Math.round(target.distanceKm * 1000)} m` : `${Number(target.distanceKm.toFixed(2))} km`);
  }
  return parts.join(', ');
}
